import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: resolve => require(["@/components/login"],resolve),
      meta: {
        title: "用户登录"
      },
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(["@/components/login"],resolve),
      meta: {
        title: "用户登录"
      },
    },
    {
      path: '/home',
      name: 'home',
      component: resolve => require(["@/components/home"],resolve),
      meta: {
        title: "首页",
        needLogin: true,
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/my',
      name: 'my',
      component: resolve => require(["@/components/my"],resolve),
      meta: {
        title: "我的",
        needLogin: true
      },
    },
    {
      path: '/device',
      name: 'device',
      component: resolve => require(["@/components/device"],resolve),
      meta: {
        title: "设备",
        needLogin: true,
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/device_detail',
      name: 'device_detail',
      component: resolve => require(["@/components/device_detail"],resolve),
      meta: {
        needLogin: true,
        title: "设备详情",
      },
    },
    {
      path: '/commodity',
      name: 'commodity',
      component: resolve => require(["@/components/commodity"],resolve),
      meta: {
        title: "商品管理",
        needLogin: true,
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/commodity_edit',
      name: 'commodity_edit',
      component: resolve => require(["@/components/commodity_edit"],resolve),
      meta: {
        needLogin: true,
        title: "商品编辑"
      },
    },
    {
      path: '/tag',
      name: 'tag',
      component: resolve => require(["@/components/tag"],resolve),
      meta: {
        title: "字典管理",
        needLogin: true,
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/tag_edit',
      name: 'tag_edit',
      component: resolve => require(["@/components/tag_edit"],resolve),
      meta: {
        needLogin: true,
        title: "字典编辑"
      },
    },
    {
      path: '/editpassword',
      name: 'editpassword',
      component: resolve => require(["@/components/editpassword"],resolve),
      meta: {
        needLogin: true,
        title: "修改密码"
      },
    },
    {
      path: '/user',
      name: 'user',
      component: resolve => require(["@/components/user"],resolve),
      meta: {
        needLogin: true,
        title: "账号管理",
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/user_edit',
      name: 'user_edit',
      component: resolve => require(["@/components/user_edit"],resolve),
      meta: {
        needLogin: true,
        title: "账号编辑"
      },
    },
    {
      path: '/grouping',
      name: 'grouping',
      component: resolve => require(["@/components/grouping"],resolve),
      meta: {
        needLogin: true,
        title: "分组管理"
      },
    },
    {
      path: '/grouping_edit',
      name: 'grouping_edit',
      component: resolve => require(["@/components/grouping_edit"],resolve),
      meta: {
        needLogin: true,
        title: "分组编辑"
      },
    },
    {
      path: '/dealer',
      name: 'dealer',
      component: resolve => require(["@/components/dealer"],resolve),
      meta: {
        needLogin: true,
        title: "经销商管理",
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/dealer_edit',
      name: 'dealer_edit',
      component: resolve => require(["@/components/dealer_edit"],resolve),
      meta: {
        needLogin: true,
        title: "经销商编辑"
      },
    },
    {
      path: '/dealer_shop',
      name: 'dealer_shop',
      component: resolve => require(["@/components/dealer_shop"],resolve),
      meta: {
        needLogin: true,
        title: "经销商门店",
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/dealer_shop_edit',
      name: 'dealer_shop_edit',
      component: resolve => require(["@/components/dealer_shop_edit"],resolve),
      meta: {
        needLogin: true,
        title: "经销商门店编辑"
      },
    },
    {
      path: '/stock_in',
      name: 'stock_in',
      component: resolve => require(["@/components/stock_in"],resolve),
      meta: {
        needLogin: true,
        title: "入库管理"
      },
    },
    {
      path: '/stock_in',
      name: 'stock_in',
      component: resolve => require(["@/components/stock_in"],resolve),
      meta: {
        needLogin: true,
        title: "入库管理"
      },
    },
    {
      path: '/stock_ining',
      name: 'stock_ining',
      component: resolve => require(["@/components/stock_ining"],resolve),
      meta: {
        needLogin: true,
        title: "入库"
      },
    },
    {
      path: '/stock_in_draft',
      name: 'stock_in_draft',
      component: resolve => require(["@/components/stock_in_draft"],resolve),
      meta: {
        needLogin: true,
        title: "入库草稿箱"
      },
    },
    {
      path: '/stock_in_list',
      name: 'stock_in_list',
      component: resolve => require(["@/components/stock_in_list"],resolve),
      meta: {
        needLogin: true,
        title: "入库列表",
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/device_operation',
      name: 'device_operation',
      component: resolve => require(["@/components/device_operation"],resolve),
      meta: {
        needLogin: true,
        title: "设备操作"
      },
    },
    {
      path: '/stock_adjust',
      name: 'stock_adjust',
      component: resolve => require(["@/components/stock_adjust"],resolve),
      meta: {
        needLogin: true,
        title: "调库管理"
      },
    },
    {
      path: '/stock_adjust_list',
      name: 'stock_adjust_list',
      component: resolve => require(["@/components/stock_adjust_list"],resolve),
      meta: {
        needLogin: true,
        title: "调库列表"
      },
    },
    {
      path: '/stock_adjusting',
      name: 'stock_adjusting',
      component: resolve => require(["@/components/stock_adjusting"],resolve),
      meta: {
        needLogin: true,
        title: "调库"
      },
    },
    {
      path: '/stock_out',
      name: 'stock_out',
      component: resolve => require(["@/components/stock_out"],resolve),
      meta: {
        needLogin: true,
        title: "出库管理"
      },
    },
    {
      path: '/stock_outing',
      name: 'stock_outing',
      component: resolve => require(["@/components/stock_outing"],resolve),
      meta: {
        needLogin: true,
        title: "出库"
      },
    },
    {
      path: '/stock_out_list',
      name: 'stock_out_list',
      component: resolve => require(["@/components/stock_out_list"],resolve),
      meta: {
        needLogin: true,
        title: "出库列表",
        keepAlive: true,
        isload:false,
      },
    },
    {
      path: '/stock_out_draft',
      name: 'stock_out_draft',
      component: resolve => require(["@/components/stock_out_draft"],resolve),
      meta: {
        needLogin: true,
        title: "出库草稿箱"
      },
    },
    {
      path: '/device_tune',
      name: 'device_tune',
      component: resolve => require(["@/components/device_tune"],resolve),
      meta: {
        needLogin: true,
        title: "设备调仓"
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js